import React from 'react';
import { cn } from '@gettactic/helpers';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export interface ReserveFormErrorsProps {
  className?: string;
}

export const ReserveFormErrors: React.FC<ReserveFormErrorsProps> = ({
  className
}) => {
  const { errorMessage } = useReserveForm();
  if (!errorMessage) return null;
  return (
    <div className={cn('pb-4 text-red-600 text-sm', className)}>
      {errorMessage.split('\n').map((line) => (
        <p key={line}>{line}</p>
      ))}
    </div>
  );
};
